import axios from "axios";

// Same-origin API so the site works on every domain it's served from (root, www, emergent.host).
export const BACKEND = "";
export const API = `${BACKEND}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("aura_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && x.msg ? `${(x.loc || []).slice(-1)[0]}: ${x.msg}` : JSON.stringify(x))).join(" ");
  if (d.errors) return d.errors.join(" • ");
  if (d.warning) return d.warning;
  if (d.msg) return d.msg;
  return String(d);
}

export async function download(path, filename) {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export async function openDoc(id) {
  const { data } = await api.post(`/documents/${id}/link`);
  window.open(BACKEND + data.path, "_blank", "noopener");
}

export async function uploadDoc(file, fields) {
  const fd = new FormData();
  fd.append("file", file);
  Object.entries(fields).forEach(([k, v]) => v != null && fd.append(k, v));
  const { data } = await api.post("/documents", fd);
  return data;
}

export const money = (n) => (n == null ? "—" : Number(n).toLocaleString("en-US", { style: "currency", currency: "USD" }));
export const fdate = (s) => (s ? new Date(s.length <= 10 ? s + "T12:00:00" : s).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—");
export const fdt = (s) => (s ? new Date(s).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "—");
export const uid = () => (crypto.randomUUID ? crypto.randomUUID() : String(Date.now() + Math.random()));
export const tourStatuses = ["draft", "published", "registration_open", "registration_closed", "waitlisted", "canceled", "completed", "archived"];
export const label = (s) => (s || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
